class ProductAdd extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', function() {
      let formData = {
        'items': [{
          'id': parseInt(this.getAttribute('data-id')),
          'quantity': 1
        }]
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then(response => {
        if (!this.error) {
          publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
          document.dispatchEvent(new CustomEvent('cart:added'));
        }
        this.error = false;
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    })
  }
}

customElements.define("product-add", ProductAdd);